<template>
    <div id="app">
        <main-header nowtab="bbs"></main-header>
        <main class="adjuster">
            <div>
                <a-carousel ref="carousel">
                    <div v-for="tab of tabList" :key="tab.key">
                        <h3>{{ tab.tab }}: 版头征求中，有意者联系@终末之扉超级粉丝</h3>
                    </div>
                </a-carousel>
            </div>
            <a-card
                class="card record-card"
                :tab-list="tabList"
                :active-tab-key="$route.name"
                @tabChange="change"
            >
                <router-view></router-view>
            </a-card>
            <div v-show="hasLogin" id="editor">
                <div>
                    <a-input v-model="title" />
                </div>
                <wang-editor v-model="editorData" @change-value="save"></wang-editor>
                <a-button type="primary" id="post" :loading="posting"
                    @click="appendThread()"
                >发布</a-button>
            </div>
            <a-result v-show="!hasLogin" title="尚未登录，请登录后发帖">
                <template #icon></template>
                <template #extra>
                <a-button type="primary">
                    <a href="/user/login.html?from">登录</a>
                </a-button>
                </template>
            </a-result>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import WangEditor from '@/components/WangEditor'
import axios from 'axios';
import { mapState } from 'vuex';
import { createFormData, getReason, scrollToElm, throttle } from '../../utils/utils';
import { boards } from './router';

export default {
    data: () => ({
        tabList: boards.map(e => ({ key: e.name, tab: e.meta.tab })),
        posting: false,
        editorData: "",
        title: "",
    }),
    computed: {
        ...mapState({ hasLogin: 'hasLogin' }),
    },
    created() {
        const draft = localStorage.getItem(`editor.draft.bbs`);
        this.editorData = draft;
        this.save = throttle((html) => {
            try {
                localStorage.setItem(`editor.draft.bbs`, html);
            } catch(e) {
                this.$message.error(`草稿保存失败: ${ e }`);
            }
        }, 15 * 1000);
    },
    methods: {
        change(key) {
            this.$refs.carousel.goTo(key);
            this.$router.push({ name: key });
        },
        async appendThread() {
            if (this.title == "") {
                alert("请输入标题！");
                return;
            }
            let content = this.editorData;
            content = content.replace(/&/g, "&amp;");
            if (content.replace(/<br>/g, "").replace(/\W/g, "") === "") {
                alert("请填写帖子内容！");
                return;
            }
            this.posting = true;

            const { data } = await axios
                .post("/backend/bbs/appendThread.php", createFormData({
                    content, title: this.title, client: 'web'
                }));
            this.posting = false;
            if (data.code == 0) {
                this.$message.success('发布成功');
                localStorage.removeItem(`editor.draft.bbs`);
                this.$router.replace(this.$route);
                scrollToElm(document.getElementById("app"));
            } else {
                const reason = getReason(data.code);
                this.$message.error(`发布失败: ${ reason }`);
            }
        },
    },
    components: {
        MainHeader, Footer, WangEditor
    }
}
</script>

<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
#editor {
    margin-top: 20px;
    text-align: left;
}
.editorContainer {
    margin: 10px 0px;
    cursor: text;
}
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
#post {
    margin-left: 15px;
}
.ant-pagination.top-pager {
    margin-top: 10px;
    margin-bottom: -10px;
}
.ant-select-dropdown.boardSelector {
    z-index: 10001;
}
</style>

<style scoped>
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}
.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
</style>